<div data-cy="grid-engine-icon-cell">
  @if (isIcon()) {
    @if (isBasicIcon()) {
      <mat-icon
        [matTooltipClass]="'regular-tooltip'"
        [matTooltip]="(tooltip() ? tooltip() + '.' + $safeNavigationMigration(value()?.toLowerCase()) : '') | translate"
        matTooltipPosition="above"
        [ngClass]="['icon-' + value(), 'table-icon-content']"
        >{{ value() }}
      </mat-icon>
    } @else {
      <mat-icon
        [matTooltipClass]="'regular-tooltip'"
        [matTooltip]="(tooltip() ? tooltip() + '.' + $safeNavigationMigration(value()?.toLowerCase()) : '') | translate"
        matTooltipPosition="above"
        [ngClass]="['icon-' + value(), 'table-icon-content']"
        [svgIcon]="$safeNavigationMigration(value()?.toLowerCase())"
      />
    }
  } @else {
    <!-- Used for filter custom filter renderer -->
    <span>{{ value() }}</span>
  }
</div>
